import { CheckCircle } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const SuccessModal = ({ isOpen, onClose, message, title = "Success" }) => {
    const { currentTheme } = useTheme();
    const isDark = currentTheme.textColor === '#FFFFFF';

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] backdrop-blur-sm animate-in fade-in duration-300">
            <div className={`rounded-2xl shadow-2xl w-full max-w-sm p-8 transform transition-all scale-100 animate-in zoom-in-95 duration-200 border ${isDark ? 'bg-[#111827] border-white/10' : 'bg-white border-gray-100'}`}>
                <div className="flex flex-col items-center text-center">
                    <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 transition-all ${isDark ? 'bg-green-500/10' : 'bg-green-100'}`}>
                        <CheckCircle className="w-8 h-8 text-green-600" />
                    </div>

                    <h3 className={`text-xl font-black uppercase tracking-widest mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>{title}</h3>
                    <p className={`text-sm font-medium mb-8 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>{message}</p>

                    <button
                        onClick={onClose}
                        className="w-full text-white py-4 rounded-2xl font-black text-xs uppercase tracking-[0.2em] transition-all shadow-xl active:scale-95"
                        style={{ backgroundColor: currentTheme.color }}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;
